import React, { useEffect, useMemo, useState } from 'react';
import '../design/MisAreas.css';
import axios from 'axios';
import { API_URL } from '../../config/config';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import L1 from '../../assets/l1.png';
import L2 from '../../assets/l2.png';
import L3 from '../../assets/l3.png';
import Mt from '../../assets/mt.png';
import Cn from '../../assets/cn.png';
import Cs from '../../assets/cs.png';
import Ea from '../../assets/ea.png';
import Fc from '../../assets/fc.png';
import Ef from '../../assets/ef.png';
import Pd from '../../assets/pd.png';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const MisAreas = ({
  plataforma,
  setPlataformaVisible,
  userId,
  seccion,
  setMisSecciones,
  setMiArea,
  setMiIdArea
}) => {
  const [tituloSeleccionado, setTituloSeleccionado] = useState('');
  const [area, setArea] = useState('');
  const [idArea, setIdArea] = useState('');
  const [botonesVisibles, setBotonesVisibles] = useState(true);

  // ✅ unidad seleccionada (1..10)
  const [unidadNumero, setUnidadNumero] = useState('');
  const [unidadesMax, setUnidadesMax] = useState('4'); // normalmente 4

  // ✅ Loading PDF (UNO SOLO)
  const [isPrinting, setIsPrinting] = useState(false);
  const [printingLabel, setPrintingLabel] = useState('');

  const fetchCiclo = () => {
    switch (seccion.grado.toLowerCase()) {
      case 'primero':
      case 'segundo':
      case 'tercero':
        return setBotonesVisibles(true); // id 1-8
      case 'cuarto':
      case 'quinto':
      case 'sexto':
        return setBotonesVisibles(false); // id 9-18
      default:
        return null;
    }
  };

  useEffect(() => {
    fetchCiclo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const seleccionarTitulo = (titulo) => setTituloSeleccionado(titulo);

  const handleErrorMessage = (message) => {
    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
      style: { fontSize: '15px', border: '1px solid red' }
    });
  };

  const handleSuccessMessage = (message) => {
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 2500,
      style: { fontSize: '16px', border: '1px solid green' }
    });
  };

  // ✅ Normalizador PDF
  const normalizarParaPdf = (text) => {
    if (text === null || text === undefined) return '';
    return String(text)
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .replace(/☐/g, '[  ]')
      .trim();
  };

  // ✅ Para comparar nombres aunque vengan con acentos/espacios diferentes
  const normalizeKey = (s) => {
    if (!s) return '';
    return String(s)
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  };

  // ✅ Placeholder cuando un área no tiene registros
  const buildEmptyRows = () => [
    {
      competencia: '',
      indicador: '',
      temas: 'SIN REGISTROS PARA ESTA ÁREA EN ESTA UNIDAD',
      actividades: '',
      aprendizaje: '',
      recursos: '',
      mejoramiento: '',
      herramienta: '',
      fechaentrega: '',
      punteo: ''
    }
  ];

  // ✅ Helpers printing
  const startPrinting = (label) => {
    setIsPrinting(true);
    setPrintingLabel(label || 'Generando PDF...');
  };

  const stopPrinting = () => {
    setIsPrinting(false);
    setPrintingLabel('');
  };

  // ✅ Areas según grado (1-8 o 9-18)
  const areasConfig = useMemo(() => {
    if (botonesVisibles) {
      return [
        { id: 1, titulo: 'Comunicación y Lenguaje L1', img: L1 },
        { id: 2, titulo: 'Comunicación y Lenguaje L2', img: L2 },
        { id: 3, titulo: 'Comunicación y Lenguaje L3', img: L3 },
        { id: 4, titulo: 'Matemáticas', img: Mt },
        { id: 5, titulo: 'Medio Social y Natural', img: Cn },
        { id: 6, titulo: 'Expresión Artística', img: Ea },
        { id: 7, titulo: 'Educación Física', img: Ef },
        { id: 8, titulo: 'Formación Ciudadana', img: Fc }
      ];
    }

    return [
      { id: 9, titulo: 'Comunicación y Lenguaje L1', img: L1 },
      { id: 10, titulo: 'Comunicación y Lenguaje L2', img: L2 },
      { id: 11, titulo: 'Comunicación y Lenguaje L3', img: L3 },
      { id: 12, titulo: 'Matemáticas', img: Mt },
      { id: 13, titulo: 'Ciencias Naturales y Tecnología', img: Cn },
      { id: 14, titulo: 'Ciencias Sociales', img: Cs },
      { id: 15, titulo: 'Expresión Artística', img: Ea },
      { id: 16, titulo: 'Educación Física', img: Ef },
      { id: 17, titulo: 'Formación Ciudadana', img: Fc },
      { id: 18, titulo: 'Productividad y Desarrollo', img: Pd }
    ];
  }, [botonesVisibles]);

  // ✅ Selección de área
  const selectArea = (a) => {
    seleccionarTitulo(a.titulo);
    setArea(a.titulo);
    setIdArea(a.id);
  };

  // ============================================================
  // ✅ PEDIR REPORTE POR "NÚMERO DE UNIDAD" (1..10) QUE TRAE TODAS ÁREAS
  // ============================================================
  const fetchReportePorNumeroUnidad = async (unidad) => {
    const grado = seccion.grado;
    let endpoint = null;

    switch (grado) {
      case 'Primero':
        endpoint = `${API_URL}/reportesPrimeroPorNumeroUnidad/${unidad}`;
        break;
      case 'Segundo':
        endpoint = `${API_URL}/reportesSegundoPorNumeroUnidad/${unidad}`;
        break;
      case 'Tercero':
        endpoint = `${API_URL}/reportesTerceroPorNumeroUnidad/${unidad}`;
        break;
      case 'Cuarto':
        endpoint = `${API_URL}/reportesCuartoPorNumeroUnidad/${unidad}`;
        break;
      case 'Quinto':
        endpoint = `${API_URL}/reportesQuintoPorNumeroUnidad/${unidad}`;
        break;
      case 'Sexto':
        endpoint = `${API_URL}/reportesSextoPorNumeroUnidad/${unidad}`;
        break;
      default:
        return null;
    }

    const resp = await axios.get(endpoint, {
      params: {
        id_docente: userId,
        id_ciclo: seccion.id_ciclo,
        id_grado: seccion.id_grado,
        id_seccion: seccion.id_seccion
      }
    });

    return resp.data;
  };

  // ============================================================
  // ✅ Firmas dinámicas según si el docente es director
  // ============================================================
  const buildFirmasData = (encabezadoBase, nombreDocente) => {
    const isTrueLike = (v) => {
      if (v === true) return true;
      if (v === false || v === null || v === undefined) return false;
      const s = String(v).trim().toLowerCase();
      return s === 'si' || s === 'sí' || s === 's' || s === '1' || s === 'true' || s === 'yes';
    };

    const esDirector = isTrueLike(
      encabezadoBase.es_director ??
      encabezadoBase.esdirector ??
      encabezadoBase.director_docente ??
      encabezadoBase.docente_director ??
      encabezadoBase.is_director ??
      encabezadoBase.director_flag
    );

    const nombreDirector = (encabezadoBase.director || '').trim();
    const nombreCtae = (encabezadoBase.ctae || '').trim();
    const distritoTexto = (encabezadoBase.distrito || '').trim();

    const izquierdaNombre = nombreDocente;
    const izquierdaCargo = esDirector ? 'Director con grados' : 'Docente';

    const derechaNombre = esDirector ? nombreCtae : nombreDirector;
    const derechaCargo = esDirector
      ? `C. T. A. E.${distritoTexto ? ` ${distritoTexto}` : ''}`
      : 'Director(a)';

    return {
      izquierda: { nombre: izquierdaNombre, cargo: izquierdaCargo },
      derecha: { nombre: derechaNombre, cargo: derechaCargo }
    };
  };

  // ============================================================
  // ✅ PDF helpers
  // ============================================================
  const getPdfLayout = () => ({
    top: 0.7,
    right: 0.7,
    bottom: 1.1,
    left: 0.7,

    titleSize1: 13,
    titleSize2: 13,
    headerFont: 11,
    tableFont: 10,
    lineWidth: 0.01,

    gapSmall: 0.3,
    gapMed: 0.45,
    gapBig: 0.65
  });

  // Función original (para fechas normales)
  const formatDateDisplay = (value) => {
    if (!value) return '';
    const v = String(value);
    const iso = v.includes('T') ? v.split('T')[0] : v;
    const [year, month, day] = iso.split('-');
    if (!year || !month || !day) return v;
    return `${day}/${month}/${year}`;
  };

  // ✅ NUEVA FUNCIÓN: Suma 1 día a la fecha y formatea
  const formatDateDisplayPlusOne = (value) => {
    if (!value) return '';
    const v = String(value);
    const iso = v.includes('T') ? v.split('T')[0] : v;
    const [yearStr, monthStr, dayStr] = iso.split('-');

    if (!yearStr || !monthStr || !dayStr) return v;

    const year = parseInt(yearStr, 10);
    const month = parseInt(monthStr, 10) - 1; // Meses son 0-indexed
    const day = parseInt(dayStr, 10);

    // Crear fecha y sumar un día
    const date = new Date(year, month, day);
    date.setDate(date.getDate() + 1);

    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();

    return `${d}/${m}/${y}`;
  };

  // ✅ ensureSpace con reserva opcional de bottom (para firmas)
  const ensureSpace = (doc, currentY, neededHeight, layout, reservedBottom = 0) => {
    const pageH = doc.internal.pageSize.getHeight();
    const limit = pageH - (layout.bottom + reservedBottom);
    if (currentY + neededHeight > limit) {
      doc.addPage();
      return layout.top;
    }
    return currentY;
  };

  // ✅ Evitar título+encabezado huérfanos:
  // asegura que quepa título + header + al menos "algo" de contenido
  const ensureTitleHeaderNotOrphan = (doc, y, layout, reservedBottom = 0) => {
    const TITLE_H = 0.55; // aprox
    const HEADER_H = 0.75; // aprox header row
    const MIN_BODY_H = 1.1; // al menos 1 fila visible (estimado)
    const needed = TITLE_H + HEADER_H + MIN_BODY_H;
    return ensureSpace(doc, y, needed, layout, reservedBottom);
  };

  const centeredText = (doc, text, y) => {
    const textWidth =
      (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
    const x = (doc.internal.pageSize.getWidth() - textWidth) / 2;
    doc.text(text, x, y);
  };

  const buildNombreDocente = (encabezadoBase) => {
    return `${encabezadoBase.primer_nombre || ''} ${encabezadoBase.segundo_nombre || ''} ${
      encabezadoBase.otros_nombres || ''
    } ${encabezadoBase.primer_apellido || ''} ${encabezadoBase.segundo_apellido || ''}`.trim();
  };

  // ✅ Footer
  const drawFooter = (doc, encabezadoBase, nombreDocente, layout) => {
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const y = pageH - layout.bottom + 0.45;
    const leftX = layout.left;
    const rightX = pageW - layout.right;

    const establecimiento = (encabezadoBase.establecimiento || '').trim();
    const direccion = `${encabezadoBase.direccion || ''}, ${encabezadoBase.municipio || ''}, ${
      encabezadoBase.departamento || ''
    }`.trim();

    const rightText = [establecimiento, direccion].filter(Boolean).join(' · ');

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);

    doc.text(nombreDocente || '', leftX, y);

    const maxRightWidth = rightX - pageW * 0.45;
    const lines = doc.splitTextToSize(rightText, maxRightWidth);
    doc.text(lines[0] || '', rightX, y, { align: 'right' });
  };

  // ============================================================
  // ✅ Firmas block + reglas
  // ============================================================
  const SIGN_BLOCK_H = 2.0;
  const SIGN_BLOCK_GAP = 0.4;
  
  // ✅ MODIFICADO: Acepta parámetro conComision para dibujar la 3ra firma
  const renderFirmasCompactas = (doc, posY, firmasData, layout, footerData, conComision = false) => {
    const blockH = conComision ? 3.8 : 1.9; // Más altura si hay comisión
    const before = posY;

    // Si no cabe el bloque, nueva página (y footer en la anterior)
    posY = ensureSpace(doc, posY, blockH, layout, 0);

    if (posY !== before && footerData) {
      drawFooter(doc, footerData.encabezadoBase, footerData.nombreDocente, layout);
    }

    const pageW = doc.internal.pageSize.getWidth();
    const usableW = pageW - layout.left - layout.right;

    const leftCenterX = layout.left + usableW * 0.25;
    const rightCenterX = layout.left + usableW * 0.75;

    const lineHalf = 4.2;
    const lineY = posY + 0.25;

    doc.setLineWidth(layout.lineWidth);

    // Solo líneas, sin bordes adicionales
    doc.line(leftCenterX - lineHalf, lineY, leftCenterX + lineHalf, lineY);
    doc.line(rightCenterX - lineHalf, lineY, rightCenterX + lineHalf, lineY);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);

    doc.text(firmasData.izquierda.nombre || '', leftCenterX, lineY + 0.55, { align: 'center' });
    doc.text(firmasData.derecha.nombre || '', rightCenterX, lineY + 0.55, { align: 'center' });

    doc.setFontSize(11);
    doc.text(firmasData.izquierda.cargo || '', leftCenterX, lineY + 1.05, { align: 'center' });
    doc.text(firmasData.derecha.cargo || '', rightCenterX, lineY + 1.05, { align: 'center' });

    // ✅ AGREGADO: Lógica para firma de comisión centrada abajo
    if (conComision) {
      const centerX = pageW / 2;
      const lineYComision = lineY + 2.0; // Espacio hacia abajo

      doc.setLineWidth(layout.lineWidth);
      doc.line(centerX - lineHalf, lineYComision, centerX + lineHalf, lineYComision);
      
      doc.setFontSize(12);
      doc.text('Comisión de Evaluación', centerX, lineYComision + 0.55, { align: 'center' });
      
      return lineYComision + 1.3;
    }

    return lineY + 1.3;
  };

  // ============================================================
  // ✅ TABLAS: util genérica
  //   - rowPageBreak configurable
  //   - proteger últimas N filas para que NO se partan (table2)
  // ============================================================
  const autoTableHeadSoloPrimera = ({
    doc,
    headRow,
    bodyRows,
    startY,
    layout,
    headFillColor = [173, 216, 230],
    fontSize = 10,
    columnStyles = {},
    footerData,
    extraBottom = 0,
    hideFirstHeader = false,

    // ✅ nuevos parámetros:
    reservedBottom = 0, // reserva para firmas u otros
    rowPageBreakMode = 'auto', // 'auto' para permitir split
    protectLastRows = 0 // N últimas filas (del bodyRows) no se parten
  }) => {
    const body = [headRow, ...bodyRows];

    doc.autoTable({
      body,
      startY,
      theme: 'grid',

      // ✅ Permitir que filas enormes se dividan entre páginas
      // (si protectLastRows aplica, evitamos split en esas últimas)
      rowPageBreak: rowPageBreakMode,
      pageBreak: 'auto',

      margin: {
        left: layout.left,
        right: layout.right,
        bottom: layout.bottom + extraBottom + reservedBottom
      },

      styles: {
        textColor: [0, 0, 0],
        lineWidth: 0.01,
        lineColor: [0, 0, 0],
        fontSize,
        overflow: 'linebreak',
        valign: 'top',
        cellPadding: 0.12
      },
      columnStyles,

      didDrawPage: () => {
        if (footerData) {
          drawFooter(doc, footerData.encabezadoBase, footerData.nombreDocente, layout);
        }
      },

      didParseCell: (d) => {
        const isFirstRow = d.row.index === 0;
        const isFirstPage = d.table.pageNumber === 1;

        // ✅ proteger últimas N filas del bodyRows (NO partirlas)
        // d.row.index incluye el headRow (0). body rows empiezan en 1.
        if (!isFirstRow && protectLastRows > 0) {
          const bodyIndex = d.row.index - 1; // 0..(bodyRows.length-1)
          const protectFrom = Math.max(0, bodyRows.length - protectLastRows);
          if (bodyIndex >= protectFrom) {
            // evita que esta fila se parta en páginas
            d.row.pageBreak = 'avoid';
          }
        }

        if (hideFirstHeader && isFirstRow && isFirstPage) {
          d.cell.styles.fillColor = [255, 255, 255];
          d.cell.styles.textColor = [255, 255, 255];
          d.cell.styles.lineWidth = 0;
          d.cell.text = '';
          d.cell.styles.minCellHeight = 0;
          d.cell.styles.cellPadding = 0;
          return;
        }

        if (isFirstRow && isFirstPage) {
          d.cell.styles.fillColor = headFillColor;
          d.cell.styles.textColor = [0, 0, 0];
          d.cell.styles.valign = 'middle';
          d.cell.styles.halign = 'center';
          d.cell.styles.fontStyle = 'bold';
          d.cell.styles.cellPadding = 0.18;
          d.cell.styles.minCellHeight = 0.6;
        }

        if (isFirstRow && !isFirstPage) {
          d.cell.styles.fillColor = [255, 255, 255];
          d.cell.styles.textColor = [255, 255, 255];
          d.cell.styles.lineWidth = 0;
          d.cell.text = '';
          d.cell.styles.minCellHeight = 0;
          d.cell.styles.cellPadding = 0;
        }
      }
    });
  };

  // ============================================================
  // ✅ Render de UNA hoja (un área)
  // ============================================================
  const renderAreaPage = ({
    doc,
    encabezadoBase,
    unidadNumeroLocal,
    nombreArea,
    rows,
    isFirstPageOfDoc,
    conComision = false // ✅ Nuevo parámetro
  }) => {
    const layout = getPdfLayout();

    if (!isFirstPageOfDoc) doc.addPage();

    let posY = layout.top;

    const nombreDocente = buildNombreDocente(encabezadoBase);
    const footerData = { encabezadoBase, nombreDocente };

    drawFooter(doc, encabezadoBase, nombreDocente, layout);

    if (encabezadoBase.logotipo) {
      const imgWidth = 0.9;
      const imgHeight = 0.9;
      const xImg = (doc.internal.pageSize.getWidth() - imgWidth) / 2;
      doc.addImage(encabezadoBase.logotipo, 'JPEG', xImg, posY, imgWidth, imgHeight);
      posY += imgHeight + layout.gapSmall;
    } else {
      posY += 0.1;
    }

    posY += 0.2;

    doc.setFontSize(layout.titleSize1);
    doc.setFont('helvetica', 'bold');
    centeredText(doc, `PLANIFICACIÓN ESCOLAR ${encabezadoBase.ciclo}`, posY);
    posY += 0.55;

    doc.setFontSize(layout.headerFont);
    doc.setLineWidth(layout.lineWidth);

    const lineBaseY = posY + 0.08;

    const writeField = (label, value, xLabel, xValue, y, xLineFrom, xLineTo) => {
      doc.setFont('helvetica', 'bold');
      doc.text(label, xLabel, y);
      doc.setFont('helvetica', 'normal');
      doc.text(value || '', xValue, y);
      doc.line(xLineFrom, y + 0.1, xLineTo, y + 0.1);
    };

    writeField(
      'Nombre del Establecimiento:',
      encabezadoBase.establecimiento || '',
      layout.left,
      7.25,
      posY,
      7.25,
      26.6
    );
    posY += 0.6;

    writeField(
      'Dirección del Establecimiento:',
      `${encabezadoBase.direccion || ''}, ${encabezadoBase.municipio || ''}, ${
        encabezadoBase.departamento || ''
      }`,
      layout.left,
      7.25,
      posY,
      7.25,
      26.6
    );
    posY += 0.6;

    doc.setFont('helvetica', 'bold');
    doc.text('Director:', layout.left, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.director || ''}`, 3.0, posY);
    doc.line(3.0, lineBaseY + 1.2, 13.0, lineBaseY + 1.2);

    doc.setFont('helvetica', 'bold');
    doc.text('Ciclo Escolar:', 13.5, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.ciclo || ''}`, 16.5, posY);
    doc.line(16.5, lineBaseY + 1.2, 18.5, lineBaseY + 1.2);

    doc.setFont('helvetica', 'bold');
    doc.text('Jornada:', 19.0, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.jornada || ''}`, 21.0, posY);
    doc.line(21.0, lineBaseY + 1.2, 26.6, lineBaseY + 1.2);

    posY += 0.6;

    doc.setFont('helvetica', 'bold');
    doc.text('Docente:', layout.left, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(nombreDocente, 3.0, posY);
    doc.line(3.0, lineBaseY + 1.8, 13.0, lineBaseY + 1.8);

    doc.setFont('helvetica', 'bold');
    doc.text('Grado:', 13.5, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.grado || ''}`, 15.0, posY);
    doc.line(15.0, lineBaseY + 1.8, 18.5, lineBaseY + 1.8);

    doc.setFont('helvetica', 'bold');
    doc.text('Sección:', 19.0, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.seccion || ''}`, 21.0, posY);
    doc.line(21.0, lineBaseY + 1.8, 22.5, lineBaseY + 1.8);

    doc.setFont('helvetica', 'bold');
    doc.text('Unidad:', 23.0, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${unidadNumeroLocal}`, 24.6, posY);
    doc.line(24.6, lineBaseY + 1.8, 26.6, lineBaseY + 1.8);

    posY += 0.6;

    doc.setFont('helvetica', 'bold');
    doc.text('Área:', layout.left, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${nombreArea}`, 2.1, posY);
    doc.line(2.1, lineBaseY + 2.4, 11.0, lineBaseY + 2.4);

    doc.setFont('helvetica', 'bold');
    doc.text('Tipo:', 11.5, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.tipo || ''}`, 13.0, posY);
    doc.line(13.0, lineBaseY + 2.4, 18.5, lineBaseY + 2.4);

    // ✅ AQUÍ SE USA LA NUEVA LÓGICA (+1 DÍA)
    const fechaDelFormateada = formatDateDisplayPlusOne(encabezadoBase.fechadel);
    doc.setFont('helvetica', 'bold');
    doc.text('Del:', 19.0, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${fechaDelFormateada}`, 20.0, posY);
    doc.line(20.0, lineBaseY + 2.4, 22.5, lineBaseY + 2.4);

    // ✅ AQUÍ SE USA LA NUEVA LÓGICA (+1 DÍA)
    const fechaAlFormateada = formatDateDisplayPlusOne(encabezadoBase.fechaal);
    doc.setFont('helvetica', 'bold');
    doc.text('Al:', 23.0, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${fechaAlFormateada}`, 23.8, posY);
    doc.line(23.8, lineBaseY + 2.4, 26.6, lineBaseY + 2.4);

    posY += layout.gapBig;

    // ============================================================
    // ✅ TABLA 1 (permitir split de filas grandes)
    // ============================================================
    // Evitar título+header huérfanos aquí también:
    posY = ensureTitleHeaderNotOrphan(doc, posY, layout, 0);

    doc.setFontSize(layout.titleSize2);
    doc.setFont('helvetica', 'bold');
    centeredText(doc, 'PLANIFICACIÓN DE CONTENIDOS', posY);
    posY += 0.42;

    const headRow1 = [
      'No.',
      'Competencia',
      'Indicador de Logro',
      'Temas y Subtemas',
      'Actividades de Aprendizaje',
      'Actividades de Evaluación',
      'Recursos'
    ];

    const bodyRows1 = rows.map((fila, index) => [
      index + 1,
      fila.competencia,
      fila.indicador,
      fila.temas,
      fila.actividades,
      fila.aprendizaje,
      fila.recursos
    ]);

    autoTableHeadSoloPrimera({
      doc,
      headRow: headRow1,
      bodyRows: bodyRows1,
      startY: posY,
      layout,
      fontSize: layout.tableFont,
      footerData,
      extraBottom: 0,

      // ✅ permitir split de filas grandes (aquí no hay firmas)
      rowPageBreakMode: 'auto',
      protectLastRows: 0,
      reservedBottom: 0
    });

    posY = doc.autoTable.previous.finalY + 0.55;

    // ============================================================
    // ✅ TABLA 2 (split de filas grandes + NO split en últimas filas + no huérfanos)
    // ============================================================
    // 1) Evitar que quede solo el título y el encabezado:
    // 2) Reservar espacio para firmas en el bottom margin (SIGN_NEEDED)
    
    // ✅ Calculamos espacio necesario dinámicamente según si hay comisión
    const espacioFirmas = conComision ? (SIGN_BLOCK_H + SIGN_BLOCK_GAP + 2.0) : (SIGN_BLOCK_H + SIGN_BLOCK_GAP);
    
    posY = ensureTitleHeaderNotOrphan(doc, posY, layout, espacioFirmas);

    doc.setFontSize(layout.titleSize2);
    doc.setFont('helvetica', 'bold');
    centeredText(doc, 'PLANIFICACIÓN DE ACTIVIDADES DE EVALUACIÓN Y MEJORAMIENTO', posY);
    posY += 0.42;

    const headRow2 = [
      'No.',
      'Temas',
      'Actividades de Aprendizaje',
      'Actividades de Mejoramiento',
      'Herramienta',
      'Fecha',
      'Punteo'
    ];

    const bodyRows2 = rows.map((fila, index) => [
      index + 1,
      fila.temas,
      fila.aprendizaje,
      fila.mejoramiento,
      normalizarParaPdf(fila.herramienta),
      fila.fechaentrega ? formatDateDisplay(fila.fechaentrega) : '',
      fila.punteo
    ]);

    const columnStyles2 = {
      0: { cellWidth: 1.0 },
      1: { cellWidth: 3.8 },
      2: { cellWidth: 7.0 },
      3: { cellWidth: 6.0 },
      4: { cellWidth: 4.0 },
      5: { cellWidth: 3.0 },
      6: { cellWidth: 1.8 }
    };

    // ✅ Reservar espacio para firmas:
    // ✅ Permitir split de filas grandes:
    // ✅ Pero NO split en últimas filas (justo antes de firmas):
    const SAFE_ROWS_BEFORE_SIGNS = 2;

    autoTableHeadSoloPrimera({
      doc,
      headRow: headRow2,
      bodyRows: bodyRows2,
      startY: posY,
      layout,
      fontSize: layout.tableFont,
      footerData,
      extraBottom: 0,
      columnStyles: columnStyles2,

      reservedBottom: espacioFirmas, // 👈 clave para que la tabla no invada el espacio de firmas
      rowPageBreakMode: 'auto', // 👈 permite dividir filas grandes
      protectLastRows: SAFE_ROWS_BEFORE_SIGNS // 👈 últimas filas NO se parten
    });

    posY = doc.autoTable.previous.finalY + 0.7;

    // Firmas
    const firmasData = buildFirmasData(encabezadoBase, nombreDocente);
    renderFirmasCompactas(doc, posY, firmasData, layout, footerData, conComision);
  };

  // ============================================================
  // ✅ PDF: TODAS LAS ÁREAS DE UNA UNIDAD
  // ============================================================
  const generarPdfTodasLasAreasDeUnidad = async (conComision = false) => {
    if (!unidadNumero) {
      handleErrorMessage('Selecciona la unidad (1-10) a imprimir.');
      return;
    }

    startPrinting(`Generando PDF de Unidad ${unidadNumero}${conComision ? ' con Comisión' : ''}...`);

    try {
      const data = await fetchReportePorNumeroUnidad(unidadNumero);

      if (!data || !data.encabezado || !Array.isArray(data.datosTabla)) {
        handleErrorMessage('No hay datos para generar el PDF.');
        return;
      }

      const agrupadoPorArea = {};
      for (const row of data.datosTabla) {
        const key = normalizeKey(row.area) || 'sin area';
        if (!agrupadoPorArea[key]) agrupadoPorArea[key] = [];
        agrupadoPorArea[key].push(row);
      }

      const areasOrdenadas = areasConfig.map((a) => a.titulo);
      const encabezadoBase = data.encabezado;

      const layout = getPdfLayout();

      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'cm',
        format: 'letter',
        margins: { top: layout.top, right: layout.right, bottom: layout.bottom, left: layout.left }
      });

      areasOrdenadas.forEach((nombreArea, idx) => {
        startPrinting(`Unidad ${unidadNumero} · Área ${idx + 1}/${areasOrdenadas.length}...`);

        const key = normalizeKey(nombreArea);
        const rows =
          agrupadoPorArea[key] && agrupadoPorArea[key].length ? agrupadoPorArea[key] : buildEmptyRows();

        renderAreaPage({
          doc,
          encabezadoBase,
          unidadNumeroLocal: unidadNumero,
          nombreArea,
          rows,
          isFirstPageOfDoc: idx === 0,
          conComision // 🔴 Pasa el flag
        });
      });

      // ✅ Ajuste en nombre de archivo
      const sufijo = conComision ? '_todas_las_areas_comision.pdf' : '_todas_las_areas.pdf';
      doc.save(`planificacion_${seccion.grado}_unidad_${unidadNumero}${sufijo}`);
      handleSuccessMessage('PDF generado con éxito.');
    } catch (err) {
      console.error(err);
      handleErrorMessage('Error al generar el PDF (revisa que exista el endpoint por número de unidad).');
    } finally {
      stopPrinting();
    }
  };

  // ============================================================
  // ✅ PDF: UNIDADES 1..N, cada unidad y cada área en hoja nueva
  // ============================================================
  // 🔴 MODIFICADO: Acepta parámetro conComision (default false)
  const generarPdfTodasUnidadesTodasLasAreas = async (conComision = false) => {
    const max = parseInt(unidadesMax || '0', 10);
    if (!max || max < 1) {
      handleErrorMessage('Selecciona cuántas unidades imprimir (ej. 4).');
      return;
    }

    startPrinting(`Generando PDF Unidades 1-${max}${conComision ? ' con Comisión' : ''}...`);

    try {
      const layout = getPdfLayout();

      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'cm',
        format: 'letter',
        margins: { top: layout.top, right: layout.right, bottom: layout.bottom, left: layout.left }
      });

      const ordenAreas = areasConfig.map((a) => a.titulo);

      let firstPage = true;

      for (let u = 1; u <= max; u++) {
        startPrinting(`Cargando datos de Unidad ${u}/${max}...`);

        const data = await fetchReportePorNumeroUnidad(u);

        if (!data || !data.encabezado || !Array.isArray(data.datosTabla)) {
          toast.info(`Unidad ${u}: sin datos (se omitió).`, { autoClose: 1800 });
          continue;
        }

        const encabezadoBase = data.encabezado;

        const agrupadoPorArea = {};
        for (const row of data.datosTabla) {
          const key = normalizeKey(row.area) || 'sin area';
          if (!agrupadoPorArea[key]) agrupadoPorArea[key] = [];
          agrupadoPorArea[key].push(row);
        }

        for (let i = 0; i < ordenAreas.length; i++) {
          const nombreArea = ordenAreas[i];
          startPrinting(`Unidad ${u}/${max} · Área ${i + 1}/${ordenAreas.length}...`);

          const key = normalizeKey(nombreArea);
          const rows =
            agrupadoPorArea[key] && agrupadoPorArea[key].length ? agrupadoPorArea[key] : buildEmptyRows();

          renderAreaPage({
            doc,
            encabezadoBase,
            unidadNumeroLocal: u,
            nombreArea,
            rows,
            isFirstPageOfDoc: firstPage,
            conComision: conComision // 🔴 Pasamos el flag
          });

          firstPage = false;
        }
      }

      // ✅ Ajuste en nombre de archivo para 1..N
      const sufijo = conComision ? '_comision.pdf' : '.pdf';
      doc.save(`planificacion_${seccion.grado}_unidades_1_a_${max}${sufijo}`);
      handleSuccessMessage('PDF generado con todas las unidades.');
    } catch (err) {
      console.error(err);
      handleErrorMessage('Error al generar el PDF de todas las unidades.');
    } finally {
      stopPrinting();
    }
  };

  // ============================================================
  // ✅ PDF UNIFICADO: OFICIO (8.5 x 13") + Header 1ra pág + Ahorro
  // ============================================================
  const generarPdfPlanificacionUnificada = async (conComision = false) => {
    const max = parseInt(unidadesMax || '0', 10);
    if (!max || max < 1) {
      handleErrorMessage('Selecciona cuántas unidades imprimir (ej. 4).');
      return;
    }

    startPrinting(`Generando Planificación Unificada (1-${max})...`);

    try {
      const layout = getPdfLayout();
      layout.bottom = 0.8; // Margen inferior optimizado

      // ⚠️ CONFIGURACIÓN TAMAÑO OFICIO (8.5 x 13 pulgadas)
      // Convertimos a CM porque el resto del layout usa CM.
      // 8.5 inch = 21.59 cm | 13 inch = 33.02 cm
      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'cm',
        // Pasamos las medidas [Alto, Ancho] en portrait, 'landscape' lo voltea.
        format: [21.59, 33.02], 
        margins: { top: layout.top, right: layout.right, bottom: layout.bottom, left: layout.left }
      });

      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();
      const rightEdge = pageW - layout.right;

      const ordenAreas = areasConfig.map((a) => a.titulo);
      let firstPage = true;

      // --- BUCLE DE UNIDADES ---
      for (let u = 1; u <= max; u++) {
        const data = await fetchReportePorNumeroUnidad(u);
        
        if (!data || !data.encabezado || !Array.isArray(data.datosTabla)) continue;

        const encabezadoBase = data.encabezado;
        const nombreDocente = buildNombreDocente(encabezadoBase);

        const agrupadoPorArea = {};
        for (const row of data.datosTabla) {
          const key = normalizeKey(row.area) || 'sin area';
          if (!agrupadoPorArea[key]) agrupadoPorArea[key] = [];
          agrupadoPorArea[key].push(row);
        }

        // --- BUCLE DE ÁREAS ---
        for (let i = 0; i < ordenAreas.length; i++) {
          const nombreArea = ordenAreas[i];
          const key = normalizeKey(nombreArea);
          const rows = agrupadoPorArea[key] || [];

          const bodyRows = (rows.length ? rows : buildEmptyRows()).map(r => [
            r.competencia || '',
            r.indicador || '',
            r.temas || '',
            r.actividades || '',
            r.aprendizaje || '',
            r.mejoramiento || '',
            r.recursos || ''
          ]);

          startPrinting(`U${u} · ${nombreArea}...`);

          if (!firstPage) doc.addPage();
          firstPage = false;

          let posY = layout.top;

          drawFooter(doc, encabezadoBase, nombreDocente, layout);

          // 1. LOGOTIPO Y TÍTULO
          if (encabezadoBase.logotipo) {
            const imgWidth = 0.8;
            const imgHeight = 0.8;
            const xImg = (pageW - imgWidth) / 2;
            doc.addImage(encabezadoBase.logotipo, 'JPEG', xImg, posY, imgWidth, imgHeight);
            posY += imgHeight + 0.2;
          } else {
            posY += 0.1;
          }

          doc.setFontSize(12);
          doc.setFont('helvetica', 'bold');
          centeredText(doc, `PLANIFICACIÓN ESCOLAR ${encabezadoBase.ciclo}`, posY);
          posY += 0.5;

          // 2. ENCABEZADO
          doc.setFontSize(10);
          doc.setLineWidth(layout.lineWidth);

          const lineBaseY = posY + 0.08;
          const gapLines = 0.55;

          // Fila 1
          doc.setFont('helvetica', 'bold');
          doc.text('Nombre del Establecimiento:', layout.left, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(encabezadoBase.establecimiento || '', 6.8, posY);
          doc.line(6.8, lineBaseY, rightEdge, lineBaseY);
          posY += gapLines;

          // Fila 2
          doc.setFont('helvetica', 'bold');
          doc.text('Dirección del Establecimiento:', layout.left, posY);
          doc.setFont('helvetica', 'normal');
          const dirFull = `${encabezadoBase.direccion || ''}, ${encabezadoBase.municipio || ''}, ${encabezadoBase.departamento || ''}`;
          doc.text(dirFull, 6.8, posY);
          doc.line(6.8, lineBaseY + gapLines, rightEdge, lineBaseY + gapLines);
          posY += gapLines;

          // Fila 3
          doc.setFont('helvetica', 'bold');
          doc.text('Director:', layout.left, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(`${encabezadoBase.director || ''}`, 3.0, posY);
          doc.line(3.0, lineBaseY + (gapLines * 2), 13.0, lineBaseY + (gapLines * 2));

          doc.setFont('helvetica', 'bold');
          doc.text('Ciclo Escolar:', 13.5, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(`${encabezadoBase.ciclo || ''}`, 16.5, posY);
          doc.line(16.5, lineBaseY + (gapLines * 2), 18.5, lineBaseY + (gapLines * 2));

          doc.setFont('helvetica', 'bold');
          doc.text('Jornada:', 19.0, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(`${encabezadoBase.jornada || ''}`, 21.0, posY);
          doc.line(21.0, lineBaseY + (gapLines * 2), rightEdge, lineBaseY + (gapLines * 2));
          posY += gapLines;

          // Fila 4
          doc.setFont('helvetica', 'bold');
          doc.text('Docente:', layout.left, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(nombreDocente, 3.0, posY);
          doc.line(3.0, lineBaseY + (gapLines * 3), 13.0, lineBaseY + (gapLines * 3));

          doc.setFont('helvetica', 'bold');
          doc.text('Grado:', 13.5, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(`${encabezadoBase.grado || ''}`, 15.0, posY);
          doc.line(15.0, lineBaseY + (gapLines * 3), 18.5, lineBaseY + (gapLines * 3));

          doc.setFont('helvetica', 'bold');
          doc.text('Sección:', 19.0, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(`${encabezadoBase.seccion || ''}`, 21.0, posY);
          doc.line(21.0, lineBaseY + (gapLines * 3), 22.5, lineBaseY + (gapLines * 3));

          doc.setFont('helvetica', 'bold');
          doc.text('Unidad:', 23.0, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(`${u}`, 24.6, posY);
          doc.line(24.6, lineBaseY + (gapLines * 3), rightEdge, lineBaseY + (gapLines * 3));
          posY += gapLines;

          // Fila 5
          doc.setFont('helvetica', 'bold');
          doc.text('Área:', layout.left, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(`${nombreArea}`, 2.1, posY);
          doc.line(2.1, lineBaseY + (gapLines * 4), 11.0, lineBaseY + (gapLines * 4));

          doc.setFont('helvetica', 'bold');
          doc.text('Tipo:', 11.5, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(`${encabezadoBase.tipo || ''}`, 13.0, posY);
          doc.line(13.0, lineBaseY + (gapLines * 4), 18.5, lineBaseY + (gapLines * 4));

          const fechaDel = formatDateDisplayPlusOne(encabezadoBase.fechadel);
          const fechaAl = formatDateDisplayPlusOne(encabezadoBase.fechaal);

          doc.setFont('helvetica', 'bold');
          doc.text('Del:', 19.0, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(`${fechaDel}`, 20.0, posY);
          doc.line(20.0, lineBaseY + (gapLines * 4), 22.5, lineBaseY + (gapLines * 4));

          doc.setFont('helvetica', 'bold');
          doc.text('Al:', 23.0, posY);
          doc.setFont('helvetica', 'normal');
          doc.text(`${fechaAl}`, 23.8, posY);
          doc.line(23.8, lineBaseY + (gapLines * 4), rightEdge, lineBaseY + (gapLines * 4));

          posY += 0.4; 

          // ---------------------------------------------------------
          // 3. TABLA
          // ---------------------------------------------------------
          const headRow = [
            'Competencia',
            'Indicadores de Logro',
            'Contenidos',
            'Actividades de Aprendizaje',
            'Actividades de Evaluación',
            'Procesos de Mejoramiento',
            'Recursos'
          ];

          doc.autoTable({
            startY: posY,
            head: [headRow],
            body: bodyRows,
            theme: 'grid',
            showHead: 'firstPage',
            styles: {
              fontSize: 9,
              cellPadding: 0.08, 
              lineWidth: 0.01,
              lineColor: [0, 0, 0], 
              textColor: [0, 0, 0],
              overflow: 'linebreak',
              valign: 'top'
            },
            headStyles: {
              fillColor: [214, 234, 248], 
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              halign: 'center',
              valign: 'middle',
              lineWidth: 0.01,
              lineColor: [0, 0, 0]
            },
            // Ajustamos anchos relativos (ahora tenemos más espacio a lo ancho)
            columnStyles: {
              0: { cellWidth: 4.0 }, // Más espacio
              1: { cellWidth: 4.0 }, 
              2: { cellWidth: 4.5 }, // Contenidos más ancho
              3: { cellWidth: 4.5 },
              4: { cellWidth: 4.0 },
              5: { cellWidth: 4.0 },
              6: { cellWidth: 'auto' }
            },
            margin: { bottom: layout.bottom + 0.5 }, 
            didDrawPage: () => {
              drawFooter(doc, encabezadoBase, nombreDocente, layout);
            }
          });

          // ---------------------------------------------------------
          // 4. OBSERVACIONES Y FIRMAS
          // ---------------------------------------------------------
          let finalY = doc.lastAutoTable.finalY + 0.8; 
          
          const espacioFirmas = conComision ? 4.5 : 2.5;
          const espacioTotalNecesario = 1.5 + espacioFirmas;
          
          const espacioDisponible = pageH - layout.bottom - finalY;

          if (espacioDisponible < espacioTotalNecesario) {
             doc.addPage();
             drawFooter(doc, encabezadoBase, nombreDocente, layout); 
             finalY = layout.top + 1.0; 
          }
          
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(10);
          doc.text('OBSERVACIONES:', layout.left, finalY);
          
          doc.setLineWidth(0.01);
          doc.line(layout.left + 3.2, finalY, rightEdge, finalY);
          
          finalY += 0.6;
          doc.line(layout.left, finalY, rightEdge, finalY);
          
          finalY += 0.6;
          
          const firmasData = buildFirmasData(encabezadoBase, nombreDocente);
          renderFirmasCompactas(doc, finalY + 0.5, firmasData, layout, null, conComision);
        }
      }

      doc.save(`Planificacion_Unificada_Oficio_1_a_${max}.pdf`);
      handleSuccessMessage('Planificación unificada (Oficio) generada.');

    } catch (error) {
      console.error(error);
      handleErrorMessage('Error al generar el PDF unificado.');
    } finally {
      stopPrinting();
    }
  };

  return (
    <section className="Areas" id="Areas">
      <ToastContainer />

      <div className="header">
        <span className="material-icons-sharp header-span title-span">hive</span>
        <h1>Mis Areas y Subáreas</h1>
      </div>

      <div className="areas-titulo">
        <h1>
          {seccion.grado} {seccion.seccion}
        </h1>
        <h2>Selecciona un Área o Subárea:</h2>
      </div>

      <div className="areas-container">
        <div className="areas">
          {areasConfig.map((a) => (
            <div key={a.id} onClick={() => selectArea(a)}>
              <img src={a.img} alt={a.titulo} className="areas-logo" />
              {a.titulo}
            </div>
          ))}
        </div>

        <div className="titulos">
          <h1>{tituloSeleccionado}</h1>

          <div style={{ marginTop: '0.8rem' }}>
            <select
              value={unidadNumero}
              onChange={(e) => setUnidadNumero(e.target.value)}
              style={{
                width: '100%',
                height: '3rem',
                fontSize: '16px',
                borderRadius: '8px',
                padding: '0 0.8rem',
                border: '1px solid #000'
              }}
              disabled={isPrinting}
            >
              <option value="" disabled>
                Selecciona unidad a imprimir (1-10)...
              </option>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                <option key={n} value={String(n)}>
                  Unidad {n}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginTop: '0.8rem' }}>
            <select
              value={unidadesMax}
              onChange={(e) => setUnidadesMax(e.target.value)}
              style={{
                width: '100%',
                height: '3rem',
                fontSize: '16px',
                borderRadius: '8px',
                padding: '0 0.8rem',
                border: '1px solid #000',
                marginTop: '0.6rem'
              }}
              disabled={isPrinting}
            >
              <option value="4">Imprimir 4 unidades (normal)</option>
              <option value="3">Imprimir 3 unidades</option>
              <option value="2">Imprimir 2 unidades</option>
              <option value="1">Imprimir 1 unidad</option>
              <option value="10">Imprimir 10 unidades</option>
            </select>
          </div>

          <div className="botones">
            <button
              className="btn-accion"
              disabled={isPrinting}
              onClick={() => {
                if (!area) {
                  handleErrorMessage('Selecciona un área o subárea antes de continuar.');
                  return;
                }
                setPlataformaVisible('plataformaMisTemas');
                setMisSecciones(seccion);
                setMiArea(area);
                setMiIdArea(idArea);
              }}
            >
              Temas
            </button>

            <button
              className="btn-accion"
              disabled={isPrinting}
              onClick={() => {
                if (!area) {
                  handleErrorMessage('Selecciona un área o subárea antes de continuar.');
                  return;
                }
                setPlataformaVisible('plataformaUnidades');
                setMisSecciones(seccion);
                setMiArea(area);
                setMiIdArea(idArea);
              }}
            >
              Planificación
            </button>

            <button
              className="btn-accion btn-pdf"
              onClick={() => generarPdfTodasLasAreasDeUnidad(false)}
              disabled={isPrinting}
              title="Genera un PDF para la unidad seleccionada con todas las áreas (cada área en página nueva)"
            >
              {isPrinting ? printingLabel || 'Generando PDF...' : 'Todas las Áreas (PDF)'}
            </button>

            {/* ✅ Botón para generar PDF de UNIDAD con Comisión */}
            <button
              className="btn-accion btn-pdf"
              onClick={() => generarPdfTodasLasAreasDeUnidad(true)}
              disabled={isPrinting}
              style={{ backgroundColor: '#4CAF50' }}
              title="PDF de la Unidad seleccionada con firma de Comisión de Evaluación"
            >
              {isPrinting ? printingLabel || 'Generando PDF...' : 'PDF con Comisión'}
            </button>

            <button
              className="btn-accion btn-year"
              onClick={() => generarPdfTodasUnidadesTodasLasAreas(false)}
              disabled={isPrinting}
              title="PDF con unidades 1..N y todas las áreas por unidad"
            >
              {isPrinting ? printingLabel || 'Generando PDF...' : `PDF Unidades 1-${unidadesMax}`}
            </button>
            
            {/* 🔴 NUEVO BOTÓN SOLICITADO: 1..N con Comisión */}
            <button
              className="btn-accion btn-year"
              onClick={() => generarPdfTodasUnidadesTodasLasAreas(true)}
              disabled={isPrinting}
              style={{ backgroundColor: '#1b5e20' }} // Un verde un poco más oscuro
              title="PDF de unidades 1..N con firma de Comisión de Evaluación"
            >
              {isPrinting ? printingLabel || 'Generando PDF...' : `PDF Unidades 1-${unidadesMax} con Comisión`}
            </button>

            {/* ✅ BOTÓN NUEVO: Planificación Unificada (1 Tabla, Todas Unidades) */}
            <button
              className="btn-accion btn-pdf"
              onClick={() => generarPdfPlanificacionUnificada(false)} // false = sin comisión, true = con comisión
              disabled={isPrinting}
              style={{ backgroundColor: '#008CBA', color: 'white' }} // Azul para diferenciar
              title="Genera un PDF con una sola tabla que incluye competencia, contenidos, actividades y evaluación."
            >
               {isPrinting && printingLabel.includes('Unificada') 
                ? 'Generando...' 
                : 'Planificación Unificada (1 Tabla)'}
            </button>
          </div>

          {isPrinting && (
            <p style={{ marginTop: '0.6rem', fontWeight: 700, fontSize: '15px' }}>
              {printingLabel}
            </p>
          )}
        </div>
      </div>

      <div className="areas-sub">
        <h1>Currículum Nacional Base</h1>
      </div>
    </section>
  );
};

export default MisAreas;